import {$} from "../../../iawp/src/js/factory";
/*!
 * jQuery serialscrolling
 *
 * Copyright 2019 Concept Factory
 * Released under the MIT license
 */

var ready = (callback) => {
    if (document.readyState != 'loading') callback();
    else document.addEventListener('DOMContentLoaded', callback);
}
ready(() => {
    (function(){
        'use strict';
        
        $.fn.serialscrolling = function(options){
            const settings = $.extend({}, $.fn.serialscrolling.defaults, options);
            const $pages = $(settings.pages);
            const $window = $(window);
            const $stack = $(this);
            const base = this;
            let $current = false;
            
            $.extend(this, {
                init: function(){
                    // Set the height of each page
                    if( settings.setHeight )
                        $window.on('resize.serialscrolling', this.handleResize).trigger('resize');
    
                    // Add selected class on scroll
                    $window.on('scroll.serialscrolling', this.handleCurrent).trigger('scroll');
                    
    
                    // Handle & bind the event on links
                    this.on('click.serialscrolling', this.handleEvent);
                },
    
                handleResize: function(){
                    $pages.css('min-height', $(this).height());
                },
    
                handleCurrent: function(){
                    let id;
                    let $trigger;
    
                    $pages.each(function(){
                        const $page = $(this);
                        if( ($page.offset().top - $window.height()/2) < $window.scrollTop() ){
                            id = $page.attr('id');
                            $trigger = $stack.filter('[href*="#'+ id +'"]');
                        }
                    });
    
                    if( $trigger && !$trigger.is($current) ){
                        base.setCurrent($trigger);
    
                        if( settings.eventListener )
                            settings.eventListener(id);
                    }
                },
    
                handleEvent: function(){
                    const $trigger = $(this);
                    const target = '#'  + $trigger.attr('href').split('#')[1];
                    const $target = $(target);
                    base.scrollTo($target, settings.duration, settings.easing);
                    return false;
                },
    
                setCurrent: function($trigger){
                    // Remove selected behavior from the previous
                    if($current) $current.parent().removeClass('current-menu-item').removeClass('current_page_item');
                    if($current) $current.blur();
                    // Set current data in the container
                    $current = $trigger;
    
                    // Add selected behavior to the target
                    $trigger.parent().addClass('current-menu-item').addClass('current_page_item');
                },
    
                scrollTo: function($target, duration, easing){
                    // Animated scrolling
                    if (window.matchMedia("(max-width: 1024px)").matches) {
                        $('#nav-btn').trigger('click')
                    }

                    $('body, html').animate({
                        scrollTop: $target.offset().top	+ settings.offsetTop
                    }, duration, easing);
                }
            });
    
            this.init();
            return this;
        };
    
    
        $.fn.serialscrolling.defaults = {
            pages: '.is-style-scrolling-item',
            duration: 800,
            easing: 'easeInOutExpo',
            offsetTop: 0,
            setHeight: false,
            eventListener: false
        };
        
    })();
    
    /*
     * jQuery Easing v1.3 - http://gsgd.co.uk/sandbox/jquery/easing/
     *
     * Uses the built in easing capabilities added In jQuery 1.1
     * to offer multiple easing options
     *
     * TERMS OF USE - jQuery Easing
     * 
     * Open source under the BSD License. 
     * 
     * Copyright Â© 2008 George McGinley Smith
     * All rights reserved.
      *
    */
    $.easing.easeInOutExpo = function (x, t, b, c, d){
        if (t==0) return b;
        if (t==d) return b+c;
        if ((t/=d/2) < 1) return c/2 * Math.pow(2, 10 * (t - 1)) + b;
        return c/2 * (-Math.pow(2, -10 * --t) + 2) + b;
    };
});